<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-loader-docs-preview></ui-loader-docs-preview></p>
<h1 id="description">Description</h1>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-loader</span> *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"loading"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-loader</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-loader</span> *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"loading"</span> [<span class="hljs-attr">animationsDisabled</span>]=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-loader</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-loader</span> *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"loading"</span> [<span class="hljs-attr">inline</span>]=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-loader</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
